import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import { getStockTransfer } from "services/data.inventory.service";

const columns = [
  { label: "Zone ID", id: "zoneID" },
  { label: "Location ID", id: "locationID" },
  { label: "To Zone ID", id: "toZone" },
  { label: "To Location ID", id: "toLocation" },
  { label: "SKU Code", id: "skuCode" },
  { label: "Pallet Nbr", id: "palletNbr" },
  { label: "Carton ID", id: "cartonID" },
  { label: "MLN", id: "mln" },
  { label: "Expiry Date", id: "expiryDate" },
  { label: "Transfer Quantity", id: "transferQuantity" },
  { label: "To Pallet Nbr", id: "toPallet" },
  { label: "To Carton ID", id: "toCartonID" },
  { label: "To MLN", id: "toMLN" },
  { label: "To Expiry Date", id: "toExpiryDate" },
];

function StockTransferDrawer({ open, setOpen, sTransferRequest, setSTransferRequest }) {

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["stock-transfer-log", { sTransferRequest }],
    queryFn: () => getStockTransfer(sTransferRequest),
    enabled: sTransferRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;
      const details = item.stockTransferDetails;
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Stock Transfer Number : </b>
                {item.stockTransferNo}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={6}>
                <b>From Warehouse Code : </b>
                {item.fromWarehouseCode}
              </Grid>
              <Grid item xs={6}>
                <b>To Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
              <Grid item xs={6}>
                <b>Reason : </b>
                {item.reason}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={details} />
          </div>
        </>
      );
    },
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setSTransferRequest(null);
  };

  return (
    <Drawer width="1100px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default StockTransferDrawer;
